import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Center,
  VStack,
  Heading,
  Input,
  Button,
  Divider,
  useToast,
  SimpleGrid,
  Text,
} from "@chakra-ui/react";
import { HiQrcode } from "react-icons/hi";
import { QrReader } from "react-qr-reader";
import Navbar from "../../components/Navbar";
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

const ManualAdd: React.FC = () => {
  const [deviceAddress, setDeviceAddress] = useState("");
  const [qrMode, setQrMode] = useState(false);
  const toast = useToast();
  const navigate = useNavigate();

  const handleScanResult = (result: any, error: any) => {
    if (error) return;
    if (result) {
      const code: string = typeof result === "string" ? result : (result?.text ?? "");

      if (/^[a-zA-Z0-9]+$/.test(code)) {
        setDeviceAddress(code);

        navigate(`/add-device/manual/overview/${code}`);
      } else {
        toast({
          title: <Trans>Invalid code</Trans>,
          status: "error",
        });
      }
    }
  };

  const handleNext = () => {
    if (!deviceAddress.trim()) {
      toast({
        title: <Trans>Please enter code</Trans>,
        status: "error",
      });
      return;
    }
    navigate(`/add-device/manual/overview/${deviceAddress.trim()}`);
  };

  return (
    <Navbar>
      <Center py={8}>
        <Box p={6} bg="white" boxShadow="lg" borderRadius="md" width={{ base: "90%", md: 500 }}>
          <VStack spacing={4} align="stretch">
            <Heading size="lg" textAlign="center">
              <Trans>Add Device Manually</Trans>
            </Heading>

            <Text>
              <Trans>Use the scan reader: </Trans>
            </Text>
            <SimpleGrid columns={1} spacing={2}>
              <Button
                leftIcon={<HiQrcode />}
                onClick={() => setQrMode(!qrMode)}
                colorScheme="teal"
                variant="outline"
              >
                {qrMode ? <Trans>Hide QR Scanner</Trans> : <Trans>Scan QR Code</Trans>}
              </Button>
            </SimpleGrid>

            {qrMode && (
              <Box height="300px" overflow="hidden">
                <QrReader
                  onResult={handleScanResult}
                  scanDelay={200}
                  constraints={{ facingMode: "environment" }}
                  containerStyle={{ width: "100%", height: "100%" }}
                  videoStyle={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              </Box>
            )}

            <Divider />

            <Text>
              <Trans>Or enter the label code manually: </Trans>
            </Text>

            <Input
              placeholder={t`e.g. 123456789abcdef`}
              value={deviceAddress}
              onChange={(e) => setDeviceAddress(e.target.value)}
              variant="filled"
            />

            <Button colorScheme="teal" onClick={handleNext}>
              <Trans>Next</Trans>
            </Button>
          </VStack>
        </Box>
      </Center>
    </Navbar>
  );
};

export default ManualAdd;
